import { Environment } from './environment.interface';

export const environment: Environment = {
  // API CONFIG
  API_CLIENT_URL: 'https://api.test.unterlagenshop.de/',

  // ADYEN CONFIG
  ADYEN_CLIENT_KEY: 'test_56X4WOB2INCDNHBNUTZCXDE7BERRONGH',
  ADYEN_ENVIRONMENT: 'test',

  // HEAP CONFIG
  HEAP_ID: '3680975755',
  STAGE: 'dev',

  // ENVIRONMENT CONFIG
  production: false,
  runBackwardCompatibilityTests: false, // Disabled to prevent 404 errors in development
};
